/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTriangleRight: {
  name: 'triangle-right';
  data: string;
} = {
  name: 'triangle-right',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M6 12V4l4 4-4 4Z" fill="currentColor"/></svg>`,
};
